import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="footer-page-container8">
      <h1>Privacy Policy</h1>
      
      <div className="footer-page-content8">
        <section className="privacy-section">

          <p className="privacy-intro">
            At Keshri Store, we value your privacy and are committed to protecting your personal information. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when 
            you visit our website or use our services.
          </p>
          
          <div className="privacy-notice">
            <p><strong>PLEASE READ THIS PRIVACY POLICY CAREFULLY. BY ACCESSING OR USING OUR SERVICES, 
            YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS PRIVACY POLICY.</strong></p>
          </div>
          
          <h2>1. Information We Collect</h2>
          
          <h3>1.1 Personal Information</h3>
          <p>
            We may collect personal information that you voluntarily provide to us when you:
          </p>
          <ul>
            <li>Register for an account</li>
            <li>Place an order</li>
            <li>Sign up for our newsletter</li>
            <li>Contact our customer service</li>
            <li>Participate in promotions or surveys</li>
          </ul>
          <p>
            This information may include:
          </p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Mailing address</li>
            <li>Phone number</li>
            <li>Date of birth</li>
            <li>Payment information</li>
            <li>Purchase history</li>
          </ul>
          
          <h3>1.2 Age Verification</h3>
          <p>
            As a tobacco retailer, we are legally required to verify that you are at least 21 years of age. 
            We may collect your date of birth and/or request verification of your identity through a third-party 
            age verification service.
          </p>
          
          <h3>1.3 Automatically Collected Information</h3>
          <p>
            When you access our website, we may automatically collect certain information, including:
          </p>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device type</li>
            <li>Operating system</li>
            <li>Pages viewed</li>
            <li>Time spent on pages</li>
            <li>Referring website or source</li>
            <li>Cookies and similar technologies</li>
          </ul>
          
          <h2>2. How We Use Your Information</h2>
          <p>
            We may use the information we collect for various purposes, including:
          </p>
          <ul>
            <li>Processing and fulfilling your orders</li>
            <li>Creating and managing your account</li>
            <li>Verifying your age</li>
            <li>Providing customer support</li>
            <li>Sending transactional emails</li>
            <li>Sending marketing communications</li>
            <li>Improving our website and services</li>
            <li>Detecting and preventing fraud</li>
            <li>Complying with legal obligations</li>
          </ul>
          
          <h2>3. Sharing Your Information</h2>
          <p>
            We may share your information with the following parties:
          </p>
          
          <h3>3.1 Service Providers</h3>
          <p>
            We may share your information with service providers who perform services on our behalf, such as:
          </p>
          <ul>
            <li>Payment processors</li>
            <li>Age verification services</li>
            <li>Shipping and fulfillment companies</li>
            <li>Customer service providers</li>
            <li>Marketing and analytics companies</li>
          </ul>
          
          <h3>3.2 Legal Requirements</h3>
          <p>
            We may disclose your information if required to do so by law or in response to valid requests 
            by public authorities (e.g., a court or government agency).
          </p>
          
          <h3>3.3 Business Transfers</h3>
          <p>
            If we are involved in a merger, acquisition, or sale of all or a portion of our assets, your 
            information may be transferred as part of that transaction.
          </p>
          
          <h2>4. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to collect information about your browsing 
            activities and to improve your experience on our website. You can control cookies through your 
            browser settings and other tools.
          </p>
          
          <h2>5. Your Privacy Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, such as:
          </p>
          <ul>
            <li>Right to access your personal information</li>
            <li>Right to correct inaccurate information</li>
            <li>Right to delete your personal information</li>
            <li>Right to restrict processing</li>
            <li>Right to data portability</li>
            <li>Right to object to processing</li>
          </ul>
          <p>
            To exercise these rights, please contact us using the information provided in the "Contact Us" section below.
          </p>
          
          <h2>6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information 
            against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
            over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
          </p>
          
          <h2>7. Data Retention</h2>
          <p>
            We will retain your personal information only for as long as necessary to fulfill the purposes outlined 
            in this Privacy Policy, unless a longer retention period is required or permitted by law.
          </p>
          
          <h2>8. Children's Privacy</h2>
          <p>
            Our services are not directed to individuals under the age of 21. We do not knowingly collect personal 
            information from individuals under 21. If you are a parent or guardian and believe your child has provided 
            us with personal information, please contact us immediately.
          </p>
          
          <h2>9. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for the privacy practices 
            or content of these third-party sites. We encourage you to review the privacy policies of any third-party 
            sites you visit.
          </p>
          
          <h2>10. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
            Privacy Policy on this page and updating the "Last Updated" date at the top of this policy. You are advised 
            to review this Privacy Policy periodically for any changes.
          </p>
          
          <h2>11. Contact Us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy, please contact us at:
          </p>
          <address>
            Keshri Store<br />
            In Front of Mahila Thana<br />
            Gola Bazar, Buxar<br />
            Bihar, PIN 802101<br />
            Email: keshritobacco.store@gmail.com<br />
            Phone: (+91) 9955059485
          </address>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 